import * as React from 'react';

import { TAdBannerPParams, TAdBannerPlaceParameters, TAdBannerSizes } from '../../../types/adBannerMicrofrontend';

/**
 * Значения размещения должны совпадать с легаси-баннером AdfoxBannerAdditionalFilters,
 * иначе адфокс отдаст другую кампанию.
 */
const PLACE = 'additional_filters';
const P_PARAMS: TAdBannerPParams = { p1: 'crzye', p2: 'fmsa' };
const SIZES: TAdBannerSizes = { width: '100%', height: 100 };

export function useAdditionalFiltersParameters(): TAdBannerPlaceParameters {
  return React.useMemo(
    (): TAdBannerPlaceParameters => ({
      carousel: null,
      deviceType: 'desktop',
      galleryPosition: null,
      isSp: false,
      pParams: P_PARAMS,
      place: PLACE,
      position: null,
      sizes: SIZES,
      tgbNativedescGeneralDesign: null,
    }),
    [],
  );
}
